import { apiRequest } from './api';

export interface DashboardStats {
  // Picklist Statistics (3 tiles - pendingProcessing moved to preprocessing)
  dueThisWeek: number;
  overdue: number;
  missing: number;
  
  // Queue Statistics (5 tiles)
  reviewQueue: number;
  errorQueue: number;
  duplicates: number;
  unknown: number;
  processedThisWeek: number;
  
  // Additional stats for detail views
  processedToday: number;
  processedThisMonth: number;
}

export interface QueueSummary {
  queueType: string;
  count: number;
  oldestItem: string | null;
}

export interface PreprocessingStats {
  uploaded: number;
  preprocessed: {
    Electric: number;
    Gas: number;
    Water: number;
    CWS: number;
  };
  failed: number;
}

export const dashboardApi = {
  async getStats(): Promise<DashboardStats> {
    return apiRequest<DashboardStats>('/api/dashboard/stats');
  },

  async getPreprocessingStats(): Promise<PreprocessingStats> {
    return apiRequest<PreprocessingStats>('/api/dashboard/preprocessing-stats');
  },

  async getQueueSummary(): Promise<QueueSummary[]> {
    return apiRequest<QueueSummary[]>('/api/dashboard/queues');
  },

  async getRecentActivity(limit: number = 10) {
    return apiRequest(`/api/dashboard/activity?limit=${limit}`);
  }
};